// extracted by mini-css-extract-plugin
export var centerList = "_jm-6";
export var centerLoc = "_jm-a";
export var centerName = "_jm-9";
export var centerOptionBody = "_jm-8";
export var centerRow = "_jm-7";
export var centerStatus = "_jm-b";
export var empty = "_jm-5";
export var externalIcon = "_jm-c";
export var fieldHeader = "_jm-2";
export var fieldHelp = "_jm-4";
export var fieldLabel = "_jm-3";
export var panel = "_jm-0";
export var removeBtn = "_jm-d";
export var section = "_jm-1";